import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import {
  coreMediaMetadataLabel,
  coreMediaPreviewMetadataLabel,
} from '../../media/core-ui-media.helpers';
import { CoreUIMediaItem } from '../../media/core-ui-media.types';
import { CoreUIAttachmentCardActionDirective } from './core-ui-attachment-card-action.directive';

export type CoreUIAttachmentCardMetadataOrder = 'size-format' | 'format-size';

@Component({
  selector: 'core-ui-attachment-card',
  templateUrl: './core-ui-attachment-card.component.html',
  styleUrls: ['./core-ui-attachment-card.component.scss'],
  standalone: false,
})
export class CoreUIAttachmentCardComponent implements OnChanges {
  @ContentChild(CoreUIAttachmentCardActionDirective)
  actionContent?: CoreUIAttachmentCardActionDirective;

  @Input() item: CoreUIMediaItem | null = null;
  @Input() hideExtension = false;
  @Input() disabled = false;
  @Input() caption: string | null = null;
  @Input() captionTemplate: TemplateRef<unknown> | null = null;
  @Input() locale = 'es';
  @Input() metadataOrder: CoreUIAttachmentCardMetadataOrder = 'size-format';
  @Input() iconName: string | null = null;
  @Input() iconColor = '#000';
  @Input() dragging = false;
  @Input() expanded: boolean | null = null;

  @Output() selected = new EventEmitter<CoreUIMediaItem>();

  private previewLoadFailed = false;

  get displayName(): string {
    const name = this.item?.name ?? '';
    if (!this.hideExtension) return name;
    const extensionIndex = name.lastIndexOf('.');
    return extensionIndex > 0 && extensionIndex < name.length - 1
      ? name.slice(0, extensionIndex)
      : name;
  }

  get previewUrl(): string | null {
    if (this.item?.type !== 'image' || this.previewLoadFailed) return null;
    return this.item.thumbnailUrl || this.item.url || null;
  }

  get displayIcon(): string {
    if (this.iconName) return this.iconName;
    if (this.item?.type === 'video') return 'play';
    return this.item?.type === 'document' ? 'icon_document' : 'image';
  }

  get displayCaption(): string {
    const caption = this.caption?.trim();
    if (caption) return caption;
    if (!this.item) return '';
    return this.metadataOrder === 'format-size'
      ? coreMediaPreviewMetadataLabel(this.item, this.locale)
      : coreMediaMetadataLabel(this.item, this.locale);
  }

  get showCaptionArrow(): boolean {
    return Boolean(this.caption?.trim());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item']) this.previewLoadFailed = false;
  }

  select(): void {
    if (!this.item || this.disabled) return;
    this.selected.emit(this.item);
  }

  handlePreviewError(): void {
    this.previewLoadFailed = true;
  }
}
